var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpsFixed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.3661C13.2163 11.3661 11.3666 13.2158 11.3666 15.4995C11.3666 17.7831 13.2163 19.6328 15.5 19.6328C17.7836 19.6328 19.6333 17.7831 19.6333 15.4995C19.6333 13.2158 17.7836 11.3661 15.5 11.3661ZM24.738 14.4661C24.2626 10.1571 20.8423 6.73681 16.5333 6.26148V4.13281H14.4666V6.26148C10.1576 6.73681 6.7373 10.1571 6.26197 14.4661H4.1333V16.5328H6.26197C6.7373 20.8418 10.1576 24.2621 14.4666 24.7375V26.8661H16.5333V24.7375C20.8423 24.2621 24.2626 20.8418 24.738 16.5328H26.8666V14.4661H24.738ZM15.5 22.7328C11.501 22.7328 8.26663 19.4985 8.26663 15.4995C8.26663 11.5005 11.501 8.26615 15.5 8.26615C19.499 8.26615 22.7333 11.5005 22.7333 15.4995C22.7333 19.4985 19.499 22.7328 15.5 22.7328Z",
    fill: "#101010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFixed);
export default __webpack_public_path__ + "static/media/gps-fixed.c47f2b2a.svg";
export { ForwardRef as ReactComponent };